import React, { useCallback } from 'react';

import { useFormContext } from 'react-hook-form';

import { useAssigneeOptionsList } from 'hooks/useAssigneeOptionsList';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import RichTextArea from 'components/common/richTextArea/richTextArea';

import { userMentionMapper } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/MainCard.utils';
import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/Details.module.scss';

export const Description = () => {
    const options = useAssigneeOptionsList();
    const { setValue, watch } = useFormContext<Risk>();

    const usersMention = options.map((item) => userMentionMapper(item.assignee));
    const handleDetails = useCallback((editorState) => {
        setValue('description', editorState, { shouldDirty: true });
    }, []);

    return (
        <>
            <div className={classes.title}>Details:</div>
            <RichTextArea
                onEditorDescription={handleDetails}
                existingData={watch('description')}
                editorContentHeight={140}
                placeholder={'Enter risk description'}
                isAutoFocus={true}
                mention={{
                    separator: ' ',
                    trigger: '@',
                    suggestions: usersMention || [],
                }}
            />
        </>
    );
};
